import React, { Component } from 'react';
import {
  Button,
  Paper,
  Grid,
  CircularProgress,
} from '@material-ui/core';
import { Link } from 'react-router-dom'

import './Job.css';
import metadata from '../metadata';

export default class JobApplicationCompleted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isDownloading: false,
      enrollLink: '',
      data: {},
      isConselor: false,
    }
    this.download = this.download.bind(this);
  }

  componentDidMount() {
    this.load();
  }

  load() {
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get('id');
    const autoDownload = params.get('autoDownload');
    if (!id) {
      return Promise.resolve();
    }
    return Promise.resolve()
      .then(() => {
        const url = `${metadata.apiUrl}/job/${id}`;
        const params = {
          method: 'GET',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
          },
        };
        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        console.log(res.data);
        this.setState({
          isLoading: false,
          data: res.data,
          enrollLink: `/job?id=${id}`,
          isConselor: res.data.roles.includes('counselor'),
        }, () => {
          if (autoDownload && this.state.isConselor) {
            this.setState({ isDownloading: true })
            return this.download();
          }
        });
      })
      .catch(() => {});
  }

  generateDownloadLink() {
    return Promise.resolve()
      .then(() => {
        const url = `${metadata.apiUrl}/download-job`;
        const params = {
          method: 'POST',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
          },
          body: JSON.stringify(this.state.data),
        };
        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      });
  }

  download() {
    if (this.state.formLink) {
      return this.openFile(this.state.formLink);
    }
    this.setState({ isDownloading: true })
    return this.generateDownloadLink()
      .then((res) => {
        console.log(res);

        this.setState({
          formLink: res,
          isDownloading: false
        })
        this.openFile(res);
      });
  }

  openFile(link) {
    setTimeout(() => {
      window.open(link, '_blank');
    }, 100);
  }

  render() {
    return (
      <Grid container className="main" justify="center">
        <Grid item xs={12} sm={10} md={8}>
          <Paper className="paper-container">
            <Grid container alignItems="flex-start" spacing={8} >
              {this.state.isLoading && <p>Loading...</p>}
              
              {!this.state.isLoading && <Grid item xs={12}>
                <h3>
                  Dear {this.state.data.firstName},
                  <br/><br/>
                  Thank you for your submission.  The Board of Directors will review all applications and will contact you for additional information 
                  and/or to arrange for a Face-to-Face Interview
                </h3>

                <p>
                  You can use the following link to edit your application before {metadata.deadline}
                  <br/> <br/>
                  <Button 
                    component={Link} 
                    to={this.state.enrollLink}
                    variant="outlined"
                    color="primary"
                    disabled={this.state.isDownloading}>
                      Edit Application
                  </Button>
                </p>

                {
                  this.state.isConselor &&
                  <h3>
                    If you apply for the "Conselor" position, you are required to mail back the recommendation letters and assay within 7 days.nts. <br/>
                  </h3>
                }

                {this.state.isConselor &&
                  <p>
                    If the pdf does not download automatically, please click the download button:
                    <br/> <br/>
                    <Button 
                        variant="outlined"
                        color="primary"
                        disabled={this.state.isDownloading}
                        onClick={this.download}>
                        { this.state.isDownloading && <CircularProgress size={15} thickness={6}/>}
                        <span>Download Mailing PDF</span>
                    </Button>
                  </p>}
              </Grid>}
            </Grid>
          </Paper>
        </Grid>
      </Grid>);
  }
}
